<script>
import { h } from 'vue'

export default {
  name: 'ClickOutside',
  props: {
    do: { type: Function, required: true },
    // e.g. '[data-dropdown-module-panel]' when content is teleported to body
    ignoreSelector: { type: String, default: '' }
  },

  mounted () {
    const clickListener = (e) => {
      // ignore clicks inside
      if (e.target === this.$el || this.$el.contains(e.target)) return
      if (this.ignoreSelector && typeof e.target.closest === 'function' && e.target.closest(this.ignoreSelector)) {
        return
      }
      this.do?.()
    }

    const keyupListener = (e) => {
      if (e.key === 'Escape') this.do?.()
    }

    document.addEventListener('click', clickListener, true) // capture helps with nested modals
    document.addEventListener('keyup', keyupListener)

    this._clickListener = clickListener
    this._keyupListener = keyupListener
  },

  beforeUnmount () {
    if (this._clickListener) document.removeEventListener('click', this._clickListener, true)
    if (this._keyupListener) document.removeEventListener('keyup', this._keyupListener)
  },

  render () {
    // Vue 3: slots are functions → call them
    const children = this.$slots.default ? this.$slots.default() : []
    // Return the first vnode (like your old behavior). Fallback to an empty div to keep a root.
    return children[0] || h('div')
  }
}
</script>
